import { CoreIcon } from '../core-icon';
import suitcaseSVG from '../../assets/icons/suitcase.svg';
import type { IconProps } from '../core-icon';

export const SuitcaseIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={suitcaseSVG} {...props} />;
};
